// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed; /* Fixes the layout */

}



.table-header {
    color: #767676;
    width: 260px;
    padding-top: 20px;
    padding-bottom: 20px;
    text-align: left;
    border-bottom: 1px solid #767676;
    font-size: 14px;
    margin-bottom: 10px;
    white-space: nowrap; /* Prevents wrapping */
}

.table-row:nth-child(even) {
    background-color: #f3f3f3;
}

.table-cell {
    color: #1C1C1C;
    padding-top: 10px;
    padding-bottom: 10px;
    /* border-bottom: 1px solid #ddd; */
    font-weight: 400;
    text-align: left;
    font-size: 16px;
    white-space: nowrap; /* Prevents wrapping */
    overflow: hidden;
    text-overflow: ellipsis; /* Adds ellipsis (...) if text overflows */
}




.table-body {
    width: 100%;
}

.secondary-color {
    color: #F16622;
}

.primary-color {
    color: #002C57;
}

.font-400 {
    font-weight: 400;
}

.table-data-color {
    color: #767676;
}

.text-header {
    margin-left: -150px;
    font-weight: bold;
}

.action-cell{
    display: flex;
    gap: 2;
}

.action-cell img{
    width: 10%;
    cursor: pointer;
}

.cell-icons{
    font-size: 30px;
    font-weight: bold;
}

  
  `, "",{"version":3,"sources":["webpack://./src/components/InspectionTabs/InspectionTable.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB,EAAE,qBAAqB;;AAE9C;;;;AAIA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,mBAAmB;IACnB,mBAAmB,EAAE,sBAAsB;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,mCAAmC;IACnC,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,mBAAmB,EAAE,sBAAsB;IAC3C,gBAAgB;IAChB,uBAAuB,EAAE,0CAA0C;AACvE;;;;;AAKA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,MAAM;AACV;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: fixed; /* Fixes the layout */\n\n}\n\n\n\n.table-header {\n    color: #767676;\n    width: 260px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    text-align: left;\n    border-bottom: 1px solid #767676;\n    font-size: 14px;\n    margin-bottom: 10px;\n    white-space: nowrap; /* Prevents wrapping */\n}\n\n.table-row:nth-child(even) {\n    background-color: #f3f3f3;\n}\n\n.table-cell {\n    color: #1C1C1C;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    /* border-bottom: 1px solid #ddd; */\n    font-weight: 400;\n    text-align: left;\n    font-size: 16px;\n    white-space: nowrap; /* Prevents wrapping */\n    overflow: hidden;\n    text-overflow: ellipsis; /* Adds ellipsis (...) if text overflows */\n}\n\n\n\n\n.table-body {\n    width: 100%;\n}\n\n.secondary-color {\n    color: #F16622;\n}\n\n.primary-color {\n    color: #002C57;\n}\n\n.font-400 {\n    font-weight: 400;\n}\n\n.table-data-color {\n    color: #767676;\n}\n\n.text-header {\n    margin-left: -150px;\n    font-weight: bold;\n}\n\n.action-cell{\n    display: flex;\n    gap: 2;\n}\n\n.action-cell img{\n    width: 10%;\n    cursor: pointer;\n}\n\n.cell-icons{\n    font-size: 30px;\n    font-weight: bold;\n}\n\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
